import React from 'react';
import { Box, Loader, Spacer, Typography } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { ModalLocal } from '@components';
import { modals } from '@modals';
import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useIsOperator } from '@store';

export const Validation: React.FC = () => {
	const t = useTranslation();
	const resource = useIsOperator() ? t('modals.validation.operator.title') : t('modals.validation.title');
	return (
		<ModalLocal
			name={modals.validation}
			middleContent={{
				content: (
					<Box
						styles={{
							flexDirection: 'column',
							alignItems: 'center',
							width: '100%',
						}}
					>
						<Loader width={80} height={80} />
						<Spacer vertical={32} />
						<Typography appearance="subtitle-100-04">{resource}</Typography>
					</Box>
				),
				type: 'custom',
			}}
		/>
	);
};
